import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=408a2eac&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=408a2eac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408a2eac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('408a2eac')) {
      api.createRecord('408a2eac', component.options)
    } else {
      api.reload('408a2eac', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=408a2eac&scoped=true&", function () {
      api.rerender('408a2eac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iJ0FwAMOH3Ye/JS/comp/GuestBox.vue"
export default component.exports